package com.gsb.vyapar.bhagya.datasource.network.response


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GithubUploadResponse(
    @SerialName("content")
    val content: Content?
) {
    @Serializable
    data class Content(
        @SerialName("download_url")
        val downloadUrl: String?
    )
}